export default "__VITE_PUBLIC_ASSET__a8908bb4__"